import { merge } from "rxjs";
import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import * as FlatModels from '@medsurf/flat-models';
import * as FlatActions from '@medsurf/flat-actions';
import * as FlatStates from '@medsurf/flat-states';

@Injectable()
export class MenuSharedFacade {
  constructor(protected store: Store) {
  }

  //<editor-fold desc="Selectors">
  currentSlideTitle$ = this.store.select(FlatStates.MenuSharedState.currentSlideTitle$);

  showFullscreen$ = this.store.select(FlatStates.MenuSharedState.showFullscreen$);
  showPrint$ = this.store.select(FlatStates.MenuSharedState.showPrint$);
  showPrintForAuthor$ = this.store.select(FlatStates.MenuSharedState.showPrintForAuthor$);
  showPrintForUser$ = this.store.select(FlatStates.MenuSharedState.showPrintForUser$);

  showVirtualPointer$ = this.store.select(FlatStates.MenuSharedState.showVirtualPointer$);
  showMarkers$ = this.store.select(FlatStates.MenuSharedState.showMarkers$);
  showSelftest$ = this.store.select(FlatStates.MenuSharedState.showSelftest$);
  showCaseHistory$ = this.store.select(FlatStates.MenuSharedState.showCaseHistory$);

  //</editor-fold>

  //<editor-fold desc="Snapshot Selectors">

  snapshot_showVirtualPointer = () => this.store.selectSnapshot(FlatStates.MenuSharedState.showVirtualPointer$);
  snapshot_showNavigator = () => this.store.selectSnapshot(FlatStates.MenuSharedState.showNavigator$);
  snapshot_showMarkers = () => this.store.selectSnapshot(FlatStates.MenuSharedState.showMarkers$);
  snapshot_showSelftest = () => this.store.selectSnapshot(FlatStates.MenuSharedState.showSelftest$);
  snapshot_showPrint = () => this.store.selectSnapshot(FlatStates.MenuSharedState.showPrint$);

  //</editor-fold>

  //<editor-fold desc="Requests">

  requestToggleFullscreen() {
    if (this.store.selectSnapshot(FlatStates.MenuSharedState.showFullscreen$)) {
      return this.store.dispatch(new FlatActions.MenuSharedActions.SetViewerDisplayMode(FlatModels.MenuSharedModels.ViewerDisplayMode.enum.NORMAL));
    }
    return this.store.dispatch(new FlatActions.MenuSharedActions.SetViewerDisplayMode(FlatModels.MenuSharedModels.ViewerDisplayMode.enum.FULLSCREEN));
  }

  requestSetPrintView(mode: FlatModels.MenuSharedModels.ViewerPrintMode) {
    return merge(
      this.store.dispatch(new FlatActions.MenuSharedActions.SetViewerDisplayMode(FlatModels.MenuSharedModels.ViewerDisplayMode.enum.PRINT)),
      this.store.dispatch(new FlatActions.MenuSharedActions.SetViewerPrintMode(mode)),
    )
  }
  
  requestToggleVirtualPointer() {
    return this.store.dispatch(new FlatActions.MenuSharedActions.ToggleVirtualPointer());
  }

  requestToggleNavigator(override: boolean | null = null) {
    return this.store.dispatch(new FlatActions.MenuSharedActions.ToggleNavigator(override));
  }

  requestToggleMarker(override: boolean | null = null) {
    return this.store.dispatch(new FlatActions.MenuSharedActions.ToggleMarker(override));
  }

  requestToggleSelftest() {
    return this.store.dispatch(new FlatActions.MenuSharedActions.ToggleSelftest());
  }

  requestToggleCaseHistory() {
    return this.store.dispatch(new FlatActions.MenuSharedActions.ToggleCaseHistory());
  }

  //</editor-fold>

}
